import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import Seo from "@/components/Seo";

export default function NotFoundPage() {
  return (
    <div className="max-w-[1000px] mx-auto px-6 lg:px-12 py-28 text-center" data-testid="not-found">
      <Seo
        title="Stranica nije pronađena"
        description="Tražena stranica ne postoji. Vratite se na naslovnu i nastavite pregledavati sadržaj."
        path="/404"
        robots="noindex,nofollow"
      />
      <div className="overline text-ink-soft">Greška 404</div>
      <h1 className="font-display text-6xl sm:text-7xl tracking-tighter font-bold text-ink mt-4 leading-none">
        Stranica nije<br />pronađena.
      </h1>
      <p className="text-ink-soft mt-6">Provjerite URL ili se vratite na naslovnu.</p>
      <Link
        to="/"
        className="inline-flex items-center gap-2 mt-8 bg-ink text-white px-6 py-3 text-sm font-medium rounded-sm hover:bg-[#112240]"
      >
        Natrag na naslovnu <ArrowUpRight className="w-4 h-4" strokeWidth={1.75} />
      </Link>
    </div>
  );
}
